import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Roles } from "src/app/models/enum";
import { User } from "src/app/models/models";
import { RoleService } from "../../services/role.service";
import { HEAD_ADMIN_ROLE } from "../../utils/user-role.utils";
import { CbtaModalComponent } from "../cbta-modal/cbta-modal.component";

@Component({
	selector: "app-cbta-switch-role-modal",
	templateUrl: "./cbta-switch-role-modal.component.html",
	styleUrls: ["./cbta-switch-role-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaSwitchRoleModalComponent {
	user: User;

	constructor(
		private dialogRef: MatDialogRef<CbtaModalComponent>,
		private roleService: RoleService,
	) {
		this.user = this.roleService.userDetails;
	}

	get role() {
		return Roles;
	}

	get headAdminRole() {
		return HEAD_ADMIN_ROLE;
	}

	switchRoleThenClose(role: string) {
		this.dialogRef.close({ role: role });
	}

	isActive(role: string) {
		return this.roleService.getUserRole() === role;
	}

	isEnableRoleButton(role: string) {
		return this.user?.roles?.includes(role);
	}
}
